export const caseInsensitiveNameComparator = (a, b) => {
  if (!a && !b)
    return 0;
  if (!a)
    return 1;
  if (!b)
    return -1;
  const a1 = a.toLocaleLowerCase();
  const b1 = b.toLocaleLowerCase();
  return a1 < b1 ? -1 :
    a1 > b1 ? 1 :
    0;
};


// WEBPACK FOOTER //
// ./src/utils/Comparators.js